// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PharmacyBiResultSearchBase } from './pharmacyBiResultSearchBase.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyBiResultSearchResponse {
    'results': Array<PharmacyBiResultSearchBase>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyBiResultSearchResponse>> = [
        {
            "name":     "results",
            "baseName": "results",
            "type":     "Array<PharmacyBiResultSearchBase>"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyBiResultSearchResponse.attributeTypeMap;
    }
}
